var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCmtechSm600Px(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.525,
    height: 70.354,
    viewBox: "0 0 108.525 70.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_336",
    "data-name": "Caminho 336",
    d: "M817.952,163.134c2.194-25.224,2.575-29.788-15.264-15.974,15.386-7.74,13.663-5.841,15.264,15.974m-23.419-18.672c21.049-7.466,25.513-9.209,4.512-16.213C810.7,136.615,811.289,135.573,794.533,144.461Zm51.538-18.55c-22.581,5.614-28.173,7.768-6.2,17.039C828.05,132.995,827.331,134.064,846.071,125.912ZM809.3,118.383c6.745,11.435,8.113,13.933-4.131,9.11C813.67,128.128,813.543,128.828,809.3,118.383Zm30.83,32.492c-14.771-14.156-22.731-19.321-15.028,3.707C822.313,139.578,825.966,140.28,840.127,150.875Zm-13.6-30.254c-7.156,13.517-.715,7.984,13.121,1.787C828.749,124.28,821.8,133.105,826.524,120.622Zm-.706-7.954c-6.571,17.679-7.524,20.686-14.651-.01C818.742,124.9,818.1,126.7,825.818,112.668Z",
    transform: "translate(-794.533 -112.658)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#acc70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075bc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-cmtech-sm-600px",
    transform: "translate(-232.654 -1108.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(254.853 1108.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_6",
    "data-name": "Ret\\xE2ngulo 6",
    width: 51.538,
    height: 50.476,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_337",
    "data-name": "Caminho 337",
    d: "M796.574,234.814a3.619,3.619,0,0,0-7.239,0v9.56l-3.619-2.324v-7.235a7.25,7.25,0,0,1,12.365-5.126l.3.325c.1-.1.2-.214.313-.325a7.239,7.239,0,0,1,12.353,5.126v9.651h-3.62v-9.651a3.617,3.617,0,1,0-7.235,0v9.651h-3.619Z",
    transform: "translate(-534.965 933.912)",
    fill: "#76b52a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_338",
    "data-name": "Caminho 338",
    d: "M858.723,229.119v3.468H852.95v12.7h-3.468v-12.7h-5.773v-3.468Z",
    transform: "translate(-565.977 933.086)",
    fill: "#575756",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_339",
    "data-name": "Caminho 339",
    d: "M892.718,232.586h-7.725v2.883h6.9a11.668,11.668,0,0,0,0,3.463h-6.9v2.9h7.726a11.687,11.687,0,0,0,2.318,3.463H881.53V229.119h13.507a11.681,11.681,0,0,0-2.32,3.468",
    transform: "translate(-586.202 933.086)",
    fill: "#575756",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_340",
    "data-name": "Caminho 340",
    d: "M951.275,238.932v6.347l-3.464-2.224V229.119h3.464v6.35h8.088v-6.35h3.463v16.172h-3.463v-6.358Z",
    transform: "translate(-621.646 933.086)",
    fill: "#575756",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_341",
    "data-name": "Caminho 341",
    d: "M922.449,239.543l2.912,1.9a8.694,8.694,0,0,1-1.2,1.471,8.086,8.086,0,1,1,0-11.424,8.162,8.162,0,0,1,1.293,1.628l-3.005,1.751a4.4,4.4,0,0,0-.733-.932,4.623,4.623,0,1,0,0,6.532,4.28,4.28,0,0,0,.733-.928",
    transform: "translate(-601.622 933.086)",
    fill: "#575756",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_342",
    "data-name": "Caminho 342",
    d: "M759.439,238.457l3.041,1.982a8.883,8.883,0,0,1-1.246,1.551,8.445,8.445,0,1,1,0-11.941,8.908,8.908,0,0,1,1.339,1.7l-3.133,1.832a4.833,4.833,0,0,0-.762-.976,4.825,4.825,0,1,0,0,6.827,4.823,4.823,0,0,0,.762-.976",
    transform: "translate(-514.164 933.912)",
    fill: "#76b52a",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCmtechSm600Px);
export default __webpack_public_path__ + "static/media/Logo-cmtech-sm-600px.d0622826ce9a8e5e6c71b3fd06b0f521.svg";
export { ForwardRef as ReactComponent };